'use client'

import { Heading, type HeadingProps } from '../../heading'

export const FullPageModalSubtitle = (props: HeadingProps) => {
  return <Heading className="text-center" fontSize="2xl" {...props} />
}
